// API Configuration
// In development: Use relative URL to leverage Vite proxy (same-origin for Safari cookie fix)
// In production: Use full URL with domain
const API_BASE_URL = import.meta.env.VITE_API_URL ||
  (import.meta.env.MODE === 'production'
    ? 'https://littlelambenglish.com/api'  // Production API URL
    : '/api');  // Development: Vite proxy handles routing to localhost:4000

// Log API URL configuration (using console since logger might not be loaded yet)
if (import.meta.env.MODE === 'production') {
  console.log('🚀 Production API URL:', API_BASE_URL);
} else {
  console.log('🔧 Development API URL:', API_BASE_URL, '(proxied to localhost:4000)');
}

export { API_BASE_URL };
